import alt from 'components/Dispatcher';

class EditCardProfileActions {
  constructor() {
    this.generateActions(
      'initializeForm',
      'updateForm',
      'toggleScorecardDialog',
      'selectScorecardToAdd',
      'addSelectedScorecard'
    );
  }
}

export default alt.createActions(EditCardProfileActions);
